package songwritersnotebook.app.viewmodels

import songwritersnotebook.app.utils.AudioHandler
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class MetronomeController(
    private val scope: CoroutineScope
) {
    private val audioHandler = songwritersnotebook.app.di.PlatformDependencyProvider().getAudioHandler()

    // --- State ---
    private val _isEnabled = MutableStateFlow(false)
    val isEnabled = _isEnabled.asStateFlow()

    private val _isMuted = MutableStateFlow(false)
    val isMuted = _isMuted.asStateFlow()

    private val _currentBeat = MutableStateFlow(-1)
    val currentBeat = _currentBeat.asStateFlow()

    // --- Actions ---
    fun toggleEnabled(bpm: Int?) {
        val newState = !_isEnabled.value
        _isEnabled.value = newState

        if (newState) {
            startInternal(bpm ?: 120)
        } else {
            stopInternal()
        }
    }

    fun toggleMuted() {
        val newMuteState = !_isMuted.value
        _isMuted.value = newMuteState
        audioHandler.setMetronomeMuted(newMuteState)
    }

    fun setTempo(bpm: Int) {
        if (_isEnabled.value) {
            // Restart to apply new tempo
            stopInternal()
            startInternal(bpm)
            _isEnabled.value = true // Keep enabled
        }
    }

    fun stop() {
        stopInternal()
        _isEnabled.value = false
    }

    private fun startInternal(bpm: Int) {
        audioHandler.startMetronome(bpm) { beat ->
            scope.launch { _currentBeat.emit(beat) }
        }
        if (_isMuted.value) {
            audioHandler.setMetronomeMuted(true)
        }
    }

    private fun stopInternal() {
        audioHandler.stopMetronome()
        _currentBeat.value = -1
    }
}
